var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 1L2.09356 11.6879C1.74475 12.1064 1.57035 12.3157 1.56768 12.4925C1.56537 12.6461 1.63384 12.7923 1.75336 12.8889C1.89085 13 2.16328 13 2.70814 13H10.0001L9.00011 21L17.9067 10.3121C18.2555 9.89358 18.4299 9.68429 18.4325 9.50754C18.4348 9.35388 18.3664 9.2077 18.2468 9.11111C18.1094 9 17.8369 9 17.2921 9H10.0001L11.0001 1Z",
    stroke: "#FF6600",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.665f6cdd0327604fae47fa142a6af93d.svg";
export { ForwardRef as ReactComponent };